module.exports = __webpack_public_path__ + "img/colored-square.096d3488.svg";